import {appendQueryString, IRequestMeta, request, RequestMethod, ResponseTimeoutError} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpClientApiUrl} from "../../../app/read_rp_environment_variables";
import {RCN_ADDRESSES_MAX_LIMIT} from "../constants/prices_search";
import {IRcnAddressesResponse, IRcnAddressSuggestion} from "../types/IRcnAddress";

export interface IFetchRcnAddressesOptions {
    /** Clamped to 1..RCN_ADDRESSES_MAX_LIMIT - RCN answers 400 above 50. */
    limit?: number;
    signal?: AbortSignal;
}

export interface IRcnAddressesSearchResponse extends IRcnAddressesResponse<IRcnAddressSuggestion> {
    /** A full page - RCN has no offset or total, so there may be more matches. */
    capped: boolean;
}

const addressRequest = request.create<IRequestMeta, IRcnAddressesResponse<IRcnAddressSuggestion>>({
    clientApiUrl: rpClientApiUrl,
    serverApiUrl: null,
    timeout: 10000
});

const clampLimit = (limit: number): number => Math.min(RCN_ADDRESSES_MAX_LIMIT, Math.max(1, Math.floor(limit) || 1));

export const fetchRcnAddresses = async (query: string, options: IFetchRcnAddressesOptions = {}): Promise<IRcnAddressesSearchResponse> => {
    const q = query.trim();
    if (!q) {
        throw new Error("RCN address search requires a non-empty query");
    }

    const limit = clampLimit(options.limit ?? RCN_ADDRESSES_MAX_LIMIT);
    const {signal} = options;
    // The request timeout only races the fetch; an own controller lets it free the connection as well.
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (signal?.aborted) {
        abort();
    }
    signal?.addEventListener("abort", abort);

    try {
        const response = await addressRequest({}, appendQueryString(apiV2Link.address.list(), {q, limit}), {
            method: RequestMethod.GET,
            credentials: "same-origin",
            signal: controller.signal
        });

        if (!response || !Array.isArray(response.addresses)) {
            throw new Error("Unexpected RCN addresses response");
        }

        return {...response, capped: response.addresses.length >= limit};
    } catch (error) {
        if (error instanceof ResponseTimeoutError) {
            abort();
        }
        throw error;
    } finally {
        signal?.removeEventListener("abort", abort);
    }
};
import {appendQueryString, IRequestMeta, request, RequestMethod, ResponseTimeoutError} from "@pg-mono/request";
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpClientApiUrl} from "../../../app/read_rp_environment_variables";
import {RCN_ADDRESSES_MAX_LIMIT} from "../constants/prices_search";
import {IRcnAddressesResponse, IRcnAddressSuggestion} from "../types/IRcnAddress";

export interface IFetchRcnAddressesOptions {
    /** Clamped to 1..RCN_ADDRESSES_MAX_LIMIT - RCN answers 400 above 50. */
    limit?: number;
    signal?: AbortSignal;
}

export interface IRcnAddressesSearchResponse extends IRcnAddressesResponse<IRcnAddressSuggestion> {
    /** A full page - RCN has no offset or total, so there may be more matches. */
    capped: boolean;
}

const addressRequest = request.create<IRequestMeta, IRcnAddressesResponse<IRcnAddressSuggestion>>({
    clientApiUrl: rpClientApiUrl,
    serverApiUrl: null,
    timeout: 10000
});

const clampLimit = (limit: number): number => Math.min(RCN_ADDRESSES_MAX_LIMIT, Math.max(1, Math.floor(limit) || 1));

export const fetchRcnAddresses = async (query: string, options: IFetchRcnAddressesOptions = {}): Promise<IRcnAddressesSearchResponse> => {
    const q = query.trim();
    if (!q) {
        throw new Error("RCN address search requires a non-empty query");
    }

    const limit = clampLimit(options.limit ?? RCN_ADDRESSES_MAX_LIMIT);
    const {signal} = options;
    // The request timeout only races the fetch; an own controller lets it free the connection as well.
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (signal?.aborted) {
        abort();
    }
    signal?.addEventListener("abort", abort);

    try {
        const response = await addressRequest({}, appendQueryString(apiV2Link.address.list(), {q, limit}), {
            method: RequestMethod.GET,
            credentials: "same-origin",
            signal: controller.signal
        });

        if (!response || !Array.isArray(response.addresses)) {
            throw new Error("Unexpected RCN addresses response");
        }

        return {...response, capped: response.addresses.length >= limit};
    } catch (error) {
        if (error instanceof ResponseTimeoutError) {
            abort();
        }
        throw error;
    } finally {
        signal?.removeEventListener("abort", abort);
    }
};
